import React from 'react';
import FoodDeliveryTabs from './FoodDeliveryTabs';

const Payouts = () => {
  return (
    <div className="min-h-screen w-full">
      <FoodDeliveryTabs />
      <div className="px-4 py-6 lg:px-8">
        <div className="mx-auto max-w-4xl space-y-6">
        <div className="bg-white px-6 py-6 rounded-lg shadow-sm border border-gray-200">
          <h2 className="text-2xl font-extrabold text-[#1F2937]">Food Delivery — Payouts</h2>
          <p className="mt-2 text-sm text-gray-600">Payouts and settlement information will appear here. Placeholder for now.</p>
        </div>
        </div>
      </div>
    </div>
  );
};

export default Payouts;
